import { useSelector } from 'react-redux'
import { Redirect, Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import { Layout } from 'src/components/Layout'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { isLoading } from 'src/redux/slices/project/selectors'
import { selectAuthorized } from 'src/redux/slices/user/selectors'
import { TabsConfig, WorkflowTopLevelProps } from 'src/types/general'

import LoginPage from './pages/LoginPage'
import ProjectsPage from './pages/ProjectsPage'
import TeamsPage from './pages/TeamsPage'
import UserPage from './pages/UserPage'

///// Component
const AccountDashboard: React.FC<React.PropsWithChildren<WorkflowTopLevelProps>> = ({
  children,
  tabValue,
}) => {
  const loading = useSelector(isLoading)
  const authorized = useSelector(selectAuthorized)
  // const error = useSelector(state => state.analysis.error)
  // const hasData = useSelector(state => state.analysis.data !== null)
  // const allSettingsConfirmed = useSelector(selectAllSettingsConfirmed)
  const { path } = useRouteMatch()

  useTabNavigation()

  const tabsConfig: TabsConfig = {
    tabs: {
      login: {
        title: 'Login',
        description: 'Login to UBEM.io',
        label: 'Login',
        disabled: false,
        hidden: authorized,
        component: <LoginPage />,
      },
      user: {
        title: 'User Account',
        description: 'Edit your user profile here.',
        label: 'User',
        disabled: false,
        hidden: !authorized,
        component: <UserPage />,
      },
      teams: {
        title: 'Teams',
        description: 'View the Teams which you are a member of.',
        label: 'Teams',
        disabled: false,
        hidden: !authorized,
        component: <TeamsPage />,
      },
      projects: {
        title: 'Projects',
        description: 'View the projects which you have access to.',
        label: 'Projects',
        disabled: false,
        hidden: !authorized,
        component: <ProjectsPage />,
      },
    },
    defaultTab: 'login',
    root: {
      title: 'User Account',
      description: 'Edit user account settings here',
      component: <div>More info coming</div>,
      redirect: true,
    },
    otherRoutes: {
      someOtherRoute: {
        component: <div>hello there</div>,
      },
    },
    // root: "analysis",
  }
  return (
    <Layout tabsConfig={tabsConfig} loading={loading}>
      {children}
    </Layout>
  )
}

export default AccountDashboard
